import styled, { css } from 'styled-components';

export const PopupContainer = styled.div`
  width: 230px;
  max-width: min(230px, 72vw);

  && .product-card-cover {
    aspect-ratio: 276 / 242;
  }

  && {
    .ant-card {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-width: 0;
      max-width: 100%;
      height: auto;
      max-height: none;
      border-radius: 10px;
      box-shadow: none;
    }

    .ant-card-cover {
      display: block !important;
      padding: 0 !important;
      border-radius: 10px 10px 0 0;
      overflow: hidden;

      .ant-image {
        width: 100% !important;
        height: auto !important;
        aspect-ratio: 1 / 1;
        display: flex !important;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 0 !important;
      }

      .ant-image-img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
      }
    }

    &[data-image-fallback='true'] .ant-card-cover .ant-image-img {
      object-fit: contain;
      padding: 12px;
      background: ${(props) => props.theme.greyBackground};
    }

    .ant-card-body {
      padding: 10px 0;
    }
  }

  @container google-map (max-height: 450px) {
    && .product-card-cover {
      aspect-ratio: auto;
      height: 130px;
    }

    && .ant-card-cover .ant-image {
      aspect-ratio: auto;
      height: 130px !important;
    }
  }
`;

const fitSlides = (slidesToShow: number) => css`
  .slick-track:not(:has(.slick-slide:nth-child(${slidesToShow + 1}))) {
    width: 100% !important;

    .slick-slide {
      width: auto !important;
      flex: 1 1 0;
      min-width: 0;
    }
  }
`;

export const ClusterCarousel = styled.div`
  .slick-track {
    display: flex;
  }

  @media (min-width: 591px) and (max-width: 900px) {
    ${fitSlides(2)}
  }

  @media (min-width: 901px) and (max-width: 1150px) {
    ${fitSlides(3)}
  }

  @media (min-width: 1151px) and (max-width: 1484px) {
    ${fitSlides(4)}
  }

  @media (min-width: 1485px) {
    ${fitSlides(5)}
  }

  .slick-slide {
    height: auto;

    > div {
      width: 100%;
      padding: 6px 15px;
      display: flex;
    }
  }

  && .carousel-card-product {
    display: flex !important;

    .product-card-cover {
      aspect-ratio: 276 / 242;
    }
  }

  .slick-dots {
    position: relative;
    padding: 20px 12px;
  }

  .carousel-card-farm {
    height: 434px;
    max-height: none;
    min-width: 0;
    max-width: none;
    width: 100%;

    .ant-card-cover {
      display: block !important;
      padding: 0 !important;

      .ant-image {
        width: 100% !important;
        height: auto !important;
        aspect-ratio: 1 / 1;
      }
    }

    .ant-card-body .container {
      width: 90%;
    }
  }
`;
